/**
 * Case-sensitive identifier identity key.
 * Identifier values are trimmed and Unicode-normalized, but their casing is
 * preserved. Never use this key as a displayed observed identifier.
 */
export function toMatchKey(value: string): string {
  return String(value ?? "").trim().normalize("NFC");
}

export function isBlankIdentifier(value: unknown): boolean {
  return typeof value !== "string" || value.trim() === "";
}

/** Stored override, or the case-sensitive identity key when null/blank. */
export function effectiveMatchKey(
  storedMatchKey: string | null | undefined,
  identifierValue: string,
): string {
  const stored = String(storedMatchKey ?? "").trim();
  return stored.length > 0 ? stored : toMatchKey(identifierValue);
}

export function identifierMatchesLookup(
  storedMatchKey: string | null | undefined,
  identifierValue: string,
  lookupKey: string,
): boolean {
  return effectiveMatchKey(storedMatchKey, identifierValue) === lookupKey;
}
